<!--Options-->
<div class="OptionDiv">
	<label>Facility:</label>
	<p-dropdown
		class="LeftMarginSmall"
		[disabled]="IsLoading() == true"
		[options]="lstFacility"
		[(ngModel)]="Facility"
		optionLabel="FacilityName"
		[filter]="true"
		filterBy="FacilityName"
		[showClear]="false"
		placeholder="Select a Facility"
	>
		<ng-template pTemplate="selectedItem">
			<div *ngIf="Facility">
				<div class="form-control NoBorder" style="text-align: left">
					{{ Facility.FacilityName }}
				</div>
			</div>
		</ng-template>
		<ng-template let-FacilityItem pTemplate="item">
			<div>
				<div class="form-control NoBorder" style="text-align: left">
					{{ FacilityItem.FacilityName }}
				</div>
			</div>
		</ng-template>
	</p-dropdown>

	<label class="LeftMargin" style="min-width: 70px">Date Range:</label>
	<select [disabled]="IsLoading() == true" class="form-control LeftMarginSmall" name="DateRangeOption" [(ngModel)]="DateRangeOption">
		<option value="" style="display: none"></option>
		<option *ngFor="let o of lstDateRangeOption" [ngValue]="o">
			{{ o.Desc }}
		</option>
	</select>

	<label *ngIf="DateRangeOption?.ID == -3" class="LeftMargin">Start Date:</label>
	<p-calendar
		*ngIf="DateRangeOption?.ID == -3"
		class="LeftMarginSmall"
		[disabled]="IsLoading() == true"
		[(ngModel)]="StartDate"
		showIcon="true"
		showButtonBar="true"
	></p-calendar>

	<label *ngIf="DateRangeOption?.ID == -3" class="LeftMargin">End Date:</label>
	<p-calendar
		*ngIf="DateRangeOption?.ID == -3"
		class="LeftMarginSmall"
		[disabled]="IsLoading() == true"
		[(ngModel)]="EndDate"
		showIcon="true"
		showButtonBar="true"
	></p-calendar>
</div>

<div class="ButtonDiv">
	<button [disabled]="IsLoading() == true" class="btn btn-primary" style="margin: 0px" (click)="onSearch()">Search</button>
	<button [disabled]="IsLoading() == true" class="btn btn-primary" style="margin: 0px 0px 0px 5px" (click)="onPrint()">Print</button>
</div>

<!--Table-->
<div class="TopMargin">
	<p-table
		#mydt
		[value]="lstScan"
		[loading]="IsLoading() == true"
		[paginator]="true"
		[(rows)]="pagerows"
		[(first)]="pagefirst"
		[showCurrentPageReport]="true"
		[resizableColumns]="false"
		sortMode="multiple"
		styleClass="p-datatable-striped"
		selectionMode="single"
		[(selection)]="SelectedVisitorPassDetail"
		dataKey="VisitorPassDetailID"
		(onRowSelect)="onRowSelect($event)"
		(onRowUnselect)="onRowUnselect($event)"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
		[rowsPerPageOptions]="[5, 10, 25, 50]"
	>
		<!--Headers-->
		<ng-template pTemplate="header">
			<!--Filter or Select from Dropdown-->
			<tr>
				<!--INSERT CUSTOM FILTERS HERE-->

				<!--LastName-->
				<th>
					<p-columnFilter type="text" field="LastName" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--FirstName-->
				<th>
					<p-columnFilter type="text" field="FirstName" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--VisitorPassDetailStatusDesc-->
				<th>
					<p-columnFilter field="VisitorPassDetailStatusDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterVisitorPassDetailStatusDesc
								[ngModel]="value"
								[options]="lstVisitorPassDetailStatusDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--LogDT-->
				<th>
					<!-- <p-columnFilter type="text" field="LogDT" matchMode="contains" [showMenu]="true"></p-columnFilter> -->
				</th>

				<!--ScannedAtLocation-->
				<th>
					<p-columnFilter field="ScannedAtLocation" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterScannedAtLocation
								[ngModel]="value"
								[options]="lstScannedAtLocation"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--VisiteeName-->
				<th>
					<p-columnFilter type="text" field="VisiteeName" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--VisitorReasonDesc-->
				<th>
					<p-columnFilter field="VisitorReasonDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterVisitorReasonDesc
								[ngModel]="value"
								[options]="lstVisitorReasonDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--Notes-->
				<th>
					<p-columnFilter type="text" field="Notes" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--ScannedAtFacility-->
				<th>
					<p-columnFilter field="ScannedAtFacility" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterScannedAtFacility
								[ngModel]="value"
								[options]="lstScannedAtFacility"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>
			</tr>

			<!--Column Names-->
			<tr style="height: 4rem">
				<!--INSERT CUSTOM COLUMNS HERE-->
				<th pSortableColumn="LastName">Last Name<p-sortIcon field="LastName"></p-sortIcon></th>
				<th pSortableColumn="FirstName">First Name<p-sortIcon field="FirstName"></p-sortIcon></th>
				<th pSortableColumn="VisitorPassDetailStatusDesc">Status<p-sortIcon field="VisitorPassDetailStatusDesc"></p-sortIcon></th>
				<th pSortableColumn="LogDT">Date/Time<p-sortIcon field="LogDT"></p-sortIcon></th>
				<th pSortableColumn="ScannedAtLocation">Scanned At<p-sortIcon field="ScannedAtLocation"></p-sortIcon></th>
				<th pSortableColumn="VisiteeName">Destination<p-sortIcon field="VisiteeName"></p-sortIcon></th>
				<th pSortableColumn="VisitorReason">Reason<p-sortIcon field="VisitorReason"></p-sortIcon></th>
				<th pSortableColumn="Notes">Notes<p-sortIcon field="Notes"></p-sortIcon></th>
				<th pSortableColumn="ScannedAtFacility">Facility<p-sortIcon field="ScannedAtFacility"></p-sortIcon></th>
			</tr>
		</ng-template>

		<!--Data-->
		<ng-template pTemplate="body" let-VisitorPassDetail>
			<tr [pSelectableRow]="VisitorPassDetail" (dblclick)="onRowDblClick(VisitorPassDetail)">
				<a [id]="'Link' + VisitorPassDetail.VisitorPassDetailID" style="display: none" [routerLink]="VisitorPassDetail.RouterLink" target="_blank"></a>

				<td *ngFor="let col of cols" style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
					{{ VisitorPassDetail[col.field] }}
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>
